<header class="with-beefburger">
  <h1>{{ title }}</h1>
  <div class="right-container">
    <div class="pendo-header-container"></div>
    @if (identity) {
        @if (monthlyTokenUsage?.totalTokenUsage && tokenUsageLimit) {
          <span class="token-counter header-pill"
                [style.--progress]="tokenUsagePercentageValue + '%'"
                matTooltip="Monthly token usage: {{ monthlyTokenUsage.totalTokenUsage | compactNumberValues }} of {{ tokenUsageLimit | compactNumberValues }} ({{tokenUsagePercentageValue | number:'1.0-0'}}%)"
                [matTooltipShowDelay]="500">
            <span class="material-icons-outlined">generating_tokens</span>
            <span class="header-token-usage">
              <span class="opacity-80">{{ monthlyTokenUsage.totalTokenUsage | compactNumberValues }}</span> / {{ tokenUsageLimit | compactNumberValues }}
            </span>
          </span>
        }
        <span class="tenant-name header-pill" matTooltip="Logged in with tenant: {{ identity.tenant }}" [matTooltipShowDelay]="500">
        <mat-icon fontIcon="people">people</mat-icon>
        {{ identity.tenant }}
      </span>
    }
    <a href="http://www.KyloePartners.com" target="_blank" class="kyloe-logo-mask white overlay-darker-purple"
       [matTooltip]="'Visit our website'"
       matTooltipShowDelay="500" appRipple></a>
    </div>
</header>

@if (monthlyTokenUsage?.totalTokenUsage && tokenUsageLimit && monthlyTokenUsage.totalTokenUsage >= tokenUsageLimit * 0.9) {
    <div id="token-limit-warn">
        <span class="material-icons-outlined">warning_amber</span>
        <p>
            Kyloe AI Assist Token Limits: You have used over 90% of your allowed tokens this month, resetting on {{getFirstDayOfNextMonth()}}. Contact your Account Manager to discuss adding additional tokens.
        </p>
    </div>
}

